import { render } from "./TaxonomyEditor.vue?vue&type=template&id=3e5e6068&scoped=true"
import script from "./TaxonomyEditor.vue?vue&type=script&lang=js"
export * from "./TaxonomyEditor.vue?vue&type=script&lang=js"

import "./TaxonomyEditor.vue?vue&type=style&index=0&id=3e5e6068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5e6068"]])

export default __exports__